class IntercomTrigger extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this.els.trigger.element, 'click', (e) => {
      e.preventDefault()
      this.openIntercomChat()
    })
  }

  openIntercomChat () {
    window.Intercom('show')
    return false;
  }
}

if (!customElements.get('intercom-trigger')) {
  customElements.define('intercom-trigger', IntercomTrigger)
}
